import { render, staticRenderFns } from "./SchoolClaimModal.vue?vue&type=template&id=d8a647ea"
import script from "./SchoolClaimModal.vue?vue&type=script&lang=js"
export * from "./SchoolClaimModal.vue?vue&type=script&lang=js"
import style0 from "./SchoolClaimModal.vue?vue&type=style&index=0&id=d8a647ea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports